"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageSeverity = exports.ImageDimensions = void 0;
const fmko_ts_common_1 = require("fmko-ts-common");
class ImageWidget extends fmko_ts_common_1.Widget {
    constructor({ src, alt, imageDimension, imageSeverity, tooltip, tooltipWidth, rounded = true, tooltipOptions = {} }) {
        super();
        this.element = document.createElement("span");
        this.element.classList.add("image-widget");
        this.imageElement = document.createElement("img");
        this.imageElement.src = src;
        this.imageElement.alt = alt;
        this.imageElement.loading = "lazy";
        this.element.appendChild(this.imageElement);
        if (imageDimension !== ImageDimensions.CUSTOM) {
            const dimensions = imageDimension || ImageDimensions.M;
            this.imageElement.classList.add(dimensions);
        }
        if (imageSeverity) {
            this.element.classList.add(imageSeverity);
        }
        if (rounded) {
            this.element.classList.add("image-widget-rounded");
        }
        if (tooltip) {
            fmko_ts_common_1.ToggleTip.createToggleTip(this.element, tooltip, {
                tooltipWidth,
                buttonBackgroundColor: this.getTooltipBackgroundColor(imageSeverity),
                ...tooltipOptions
            });
        }
    }
    getImage() {
        return this.imageElement;
    }
    setSrc(src) {
        this.imageElement.src = src;
    }
    setAlt(alt) {
        this.imageElement.alt = alt;
    }
    getTooltipBackgroundColor(imageSeverity) {
        switch (imageSeverity) {
            case ImageSeverity.NO_BG:
                return fmko_ts_common_1.ButtonBackgroundColor.DEFAULT;
            case ImageSeverity.INFO:
                return fmko_ts_common_1.ButtonBackgroundColor.GREY;
            case ImageSeverity.WARNING:
                return fmko_ts_common_1.ButtonBackgroundColor.WARNING;
            case ImageSeverity.ERROR:
                return fmko_ts_common_1.ButtonBackgroundColor.ERROR;
            default:
                return fmko_ts_common_1.ButtonBackgroundColor.DEFAULT;
        }
    }
}
exports.default = ImageWidget;
var ImageDimensions;
(function (ImageDimensions) {
    ImageDimensions["XS"] = "svg-extra-small";
    ImageDimensions["S"] = "svg-small";
    ImageDimensions["M"] = "svg-medium";
    ImageDimensions["M_NO_CROP"] = "svg-medium-no-crop";
    ImageDimensions["L"] = "svg-large";
    ImageDimensions["L_NO_CROP"] = "svg-large-no-crop";
    ImageDimensions["XL"] = "svg-extra-large";
    ImageDimensions["XXL"] = "svg-extra-extra-large";
    ImageDimensions["FIELD"] = "svg-field";
    ImageDimensions["CUSTOM"] = "";
})(ImageDimensions = exports.ImageDimensions || (exports.ImageDimensions = {}));
var ImageSeverity;
(function (ImageSeverity) {
    ImageSeverity["NO_BG"] = "";
    ImageSeverity["INFO"] = "image-widget-info";
    ImageSeverity["WARNING"] = "image-widget-warning";
    ImageSeverity["ERROR"] = "image-widget-error";
})(ImageSeverity = exports.ImageSeverity || (exports.ImageSeverity = {}));
//# sourceMappingURL=ImageWidget.js.map